"use client";

import { Link, SideNavItem, SideNavLinkText } from "@carbon/react";
import type { ComponentType } from "react";
import NextLink from "next/link";
import { SideNavRailTooltip } from "@/components/SideNavRailTooltip";

export function AppSideNavLink({
  href,
  label,
  renderIcon: Icon,
  isActive,
  showRailTip,
}: {
  href: string;
  label: string;
  renderIcon: ComponentType<{ size?: number }>;
  isActive: boolean;
  showRailTip: boolean;
}) {
  const className = [
    "cds--side-nav__link",
    isActive ? "cds--side-nav__link--current" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const link = (
    <Link
      as={NextLink}
      href={href}
      className={className}
      aria-current={isActive ? "page" : undefined}
    >
      <div className="cds--side-nav__icon cds--side-nav__icon--small">
        <Icon />
      </div>
      <SideNavLinkText>{label}</SideNavLinkText>
    </Link>
  );

  return (
    <SideNavItem>
      <SideNavRailTooltip label={label} show={showRailTip}>
        {link}
      </SideNavRailTooltip>
    </SideNavItem>
  );
}
